export type PJMediaType = 'picture' | 'document' | 'video'

export type PJItem = {
    id: string
    file: File
    url: string
    name: string
    mediaType: string
    remoteUrl?: string
    mediaId?: string
}

export type CardContainerPJProps = {
    title: string
    list: PJItem[]
    isUploading?: boolean
    onRenaming: (targetId: string, name: string) => void
    onPreview: (targetId: string) => void
    onConfirmDelete: (targetId: string) => void
}

export type TransmissionPJQuestion = {
    id?: string
    sectionLabel: string
    title: string
    hint?: string
    required?: boolean
    optional?: boolean
}

export type TransmissionPJProps = {
    question: TransmissionPJQuestion
    initialValue?: any
    onAnswer?: (value: any) => void
}

export type TransmissionPJComponentProps = TransmissionPJProps

export const PJ_CONSTANTS = {
    MAX_FILES: 8,
    MAX_BYTES: 5 * 1024 * 1024,
    ACCEPT_TYPES:
        'image/jpeg,image/jpg,image/png,video/quicktime,video/mp4,application/pdf,.pdf,.mov,.jpeg,.jpg,.png,.mp4',
} as const

export type DialogRenameProps = {
    open: boolean
    title: string
    value: string
    onClose: () => void
    onChangeValue: (next: string) => void
    onConfirm: () => void
    isConfirmDisabled?: boolean
}

export type DialogPreviewProps = {
    open: boolean
    onClose: () => void
    target?: PJItem
}

export type DialogConfirmDeleteProps = {
    open: boolean
    onClose: () => void
    onConfirm: () => void
}

export type TransmissionPJModalState = {
    open: boolean
    targetId?: string
    name?: string
}
